import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "../views/TelaInicial.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/novo-pedido/:id?/:consulta?/:savePrevent?",
    name: "novoPedido",
    component: () => import("../views/PedidoDetalhes.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/novo-pedido/cliente/:cliente?",
    name: "novoPedidoCliente",
    component: () => import("../views/PedidoDetalhes.vue"),
    props: (route) => ({ cliente: parseInt(route.params.cliente) }),
    //props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/lista-pedidos/:cliente?/:nomeCliente?",
    name: "pedidos",
    component: () => import("../views/PedidoLista.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/lista-clientes",
    name: "clientes",
    component: () => import(/* webpackChunkName: "lista-clientes" */ "../views/ClienteLista.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/lista-produtos",
    name: "produtos",
    component: () => import(/* webpackChunkName: "lista-produtos" */ "../views/ProdutoLista.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/pedido-itens",
    name: "itens",
    component: () => import(/* webpackChunkName: "pedido-itens" */ "../components/PedidoItens.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/novo-cliente/:idCliente?",
    name: "novoCliente",
    component: () => import("../views/ClienteCadastro.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/propriedades-oticas/:idReceita/:clienteReceita",
    name: "propOticas",
    component: () => import("../views/PropriedadesOticas.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/nova-propriedade-otica/:cliente/:clienteReceita",
    name: "novaPropOtica",
    component: () => import("../views/PropriedadesOticas.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/contas-receber",
    name: "contasReceber",
    component: () => import("../views/ContasReceber.vue"),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem("fluxus_mobile_token");
  if (to.meta.requiresAuth && !token) {
    next("/login");
  } else {
    next();
  }
});

export default router;
